import React, { FunctionComponent, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import SvgDecoration from '../generated/svg/decoration'
import { useBreakpoint } from '../hooks/use-breakpoint'
import { AutoImage } from './auto-image'
import { SectionContext } from './content-container'

const Outer = styled.div`
  position: relative;
  min-width: 12rem;
  color: #9c91bd;
  border-bottom: 0.175rem solid currentcolor;
  padding: 0.5rem 2rem;
  align-self: center;
  @media (max-width: 40rem){
    color: #ff0000;
  }
`

const Label = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.2em;
`

const Decoration = styled.div`
  position: absolute;
  bottom: 0;
  left: -0.5rem;
  @media (max-width: 40rem){
    left: -1rem;
  }
  svg {
    display: block;
    height: 1.75rem;
    width: auto;
  }
  img {
    height: 3.5rem;
  }
`



type SectionTitleProps = {
}
export const SectionTitle: FunctionComponent<SectionTitleProps> = ({children}) => {
  const countRef = useContext(SectionContext)
  const [count, setCount] = useState(0)
  const isMobile = useBreakpoint('40rem')
  useEffect(() => {
    setCount(countRef.current)
    countRef.current += 1
  }, [])
  return <Outer>
    <Decoration>
      {
        isMobile ?
        <AutoImage src={`/images/m_${(count + 1).toString().padStart(2, '0')}.png`} /> :
        <SvgDecoration />
      }
      
    </Decoration>
    <Label>
      {children}
    </Label>
  </Outer>
}